export default __webpack_public_path__ + "static/media/people.9002cff8.svg";